// Tiny adapter that lives in the WidgetFrame header. Subscribes to the
// same `coin` widget setting the body uses (via useWidgetSetting) and
// renders the interactive picker unconditionally — coin is always
// editable, edit-mode only controls drag/resize/layout-level changes.

import React from 'react';
import WidgetCoinPicker from '../WidgetCoinPicker';
import { useWidgetSetting } from '../cockpitContext.jsx';

function CoinPickerHeader({ instanceId, defaultCoin }) {
  const [coin, setCoin] = useWidgetSetting(instanceId, 'coin', defaultCoin);
  return <WidgetCoinPicker value={coin} onChange={setCoin} />;
}

export default React.memo(CoinPickerHeader);
